import { Component, Input, OnInit } from '@angular/core';
import { ScenarioResponseDto } from '@cloud-twin-v2/generated/simulation.generated.client';
import { MoConnectFormSimulationOptionComponent } from '../mo-connect-form-simulation-option/mo-connect-form-simulation-option.component';

@Component({
    selector: 'tc-mo-connect-form-scenario-option',
    templateUrl: './mo-connect-form-scenario-option.component.html',
    styleUrls: ['./mo-connect-form-scenario-option.component.scss'],
    standalone: false
})
export class MoConnectFormScenarioOptionComponent
  extends MoConnectFormSimulationOptionComponent
  implements OnInit
{
  @Input() scenario: ScenarioResponseDto;

  ngOnInit(): void {}
}
